import $ from 'jquery';
import * as bootstrap from 'bootstrap';
import htmx from 'htmx.org';
import './js/bs-triggers.js';
import './js/coa-summary-tables.js';
import './js/widget-counters.js';
import './js/list.js';

window.$ = $;
window.jQuery = $;
window.bootstrap = bootstrap;
window.htmx = htmx;

const helloWorld = () => console.log("javascript loaded!")
helloWorld();

console.log("Bootstrap loaded!", bootstrap);

// global bootstrap initializations
// const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
// const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))
